export const convertVariablesToConsume = (
  variables: Record<string, any> = {}
) => {
  if (!variables || typeof variables !== 'object') {
    return variables;
  }

  const newVariable = { ...variables };

  if (newVariable['schedule_interview']) {
    const interview = newVariable['schedule_interview'];
    newVariable.interview = interview;
    delete newVariable['schedule_interview'];
  }

  return newVariable;
};
